export const ACCESS_TYPES = {
  INTEGRATION: 'integration',
  TENANT: 'tenant',
};

export const getAccessType = (apiUser = {}) => {
  const hasIntegration = !!(
    apiUser.external_application?.id || apiUser.external_application_id
  );
  const hasGroup = !!(apiUser.group?.id || apiUser.group_id);

  return hasGroup && !hasIntegration
    ? ACCESS_TYPES.TENANT
    : ACCESS_TYPES.INTEGRATION;
};

export const getApiUserScope = (apiUser = {}) => {
  if (apiUser?.school?.name) {
    return { type: 'school', name: apiUser.school.name };
  }
  if (apiUser?.unit?.name) {
    return { type: 'unit', name: apiUser.unit.name };
  }
  if (apiUser?.group?.name) {
    return { type: 'group', name: apiUser.group.name };
  }
  return null;
};

export const createAPIUserModel = (apiUser = {}) => {
  return {
    id: apiUser.id || null,
    accessType: getAccessType(apiUser),
    externalApplicationId: apiUser.external_application?.id || '',
    groupId: apiUser.group?.id || '',
    unitId: apiUser.unit?.id || '',
    schoolId: apiUser.school?.id || '',
    name: apiUser.name || '',
    email: apiUser.email || '',
    password: '',
    passwordConfirmation: '',
  };
};

const toIntOrNull = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

export const createAPIUserRequestModel = (apiUser = {}) => {
  const isUpdate = !!apiUser.id;
  const isTenant =
    (apiUser.accessType || getAccessType(apiUser)) === ACCESS_TYPES.TENANT;

  const apiUserRequestModel = {
    id: apiUser.id,
    name: apiUser.name,
    email: apiUser.email,
  };

  // On update, the ids of the side that is not in use are sent as explicit
  // nulls so the API clears them when the access type is switched.
  if (isTenant) {
    apiUserRequestModel.group_id = toIntOrNull(
      apiUser.groupId ?? apiUser.group_id ?? apiUser.group?.id
    );
    apiUserRequestModel.unit_id = toIntOrNull(
      apiUser.unitId ?? apiUser.unit_id ?? apiUser.unit?.id
    );
    apiUserRequestModel.school_id = toIntOrNull(
      apiUser.schoolId ?? apiUser.school_id ?? apiUser.school?.id
    );
    if (isUpdate) apiUserRequestModel.external_application_id = null;
  } else {
    apiUserRequestModel.external_application_id = toIntOrNull(
      apiUser.externalApplicationId ||
        apiUser.external_application_id ||
        apiUser.external_application?.id
    );
    if (isUpdate) {
      apiUserRequestModel.group_id = null;
      apiUserRequestModel.unit_id = null;
      apiUserRequestModel.school_id = null;
    }
  }

  if (apiUser.password && apiUser.passwordConfirmation) {
    apiUserRequestModel.password = apiUser.password;
    apiUserRequestModel.password_confirmation = apiUser.passwordConfirmation;
  }

  return apiUserRequestModel;
};
